import { getJSON } from 'bv-fetch';

const emptyResponse = () => ({});

export default (locale) => getJSON(`/bv_api/dictionary/${locale}/suspension_reasons`).catch(emptyResponse);
